export function saoPauloCivilDate(at: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(at);
  const value = (type: Intl.DateTimeFormatPartTypes) => parts.find(part => part.type === type)?.value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}

/** Dates are civil dates, inclusive at both ends, rather than UTC instants. */
export function isCurrentArt(art: { status: string; dataInicio: string; dataFim?: string | null }, today = saoPauloCivilDate()): boolean {
  return art.status === 'ativa' && art.dataInicio <= today && (!art.dataFim || art.dataFim >= today);
}
